import React from 'react';
import { VStack, Text } from 'native-base';
export interface HeaderTitleProps {
  title?: string;
  subtitle?: string;
}

export function HeaderTitle({
  title = undefined,
  subtitle = undefined,
}: HeaderTitleProps) {
  return (
    <VStack space="4px" alignItems="center" justifyContent={'center'}>
      <Text fontFamily={'heading'} color="white" fontWeight={700} fontSize={18}>
        {title}
      </Text>
      {subtitle ? (
        <Text color={'surface.500'} fontSize={13} lineHeight={13}>
          {subtitle}
        </Text>
      ) : null}
    </VStack>
  );
}
